import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/translation/en.json';
import krTranslation from './locales/translation/kr.json';
import vnTranslation from './locales/translation/vn.json';

const i18nInstance = i18n.use(initReactI18next);

i18nInstance.init({
  resources: {
    en: { translation: enTranslation },
    kr: { translation: krTranslation },
    vn: { translation: vnTranslation },
  },
  fallbackLng: 'en',
  lng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
